/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { EntityId, List, SiteAdsTopic } from "./data-contracts";

/**
 * @description Updates the advertising configuration for a site, including the review status and topic category used to select relevant ads. This controls GitBook's monetization feature for sites opted into the ads program.
 * @tags site-ads
 * @name UpdateSiteAdsById
 * @summary Update the advertising settings for a site
 * @request POST:/orgs/{organizationId}/sites/{siteId}/ads
 * @secure
 */

// @ts-ignore
export const updateSiteAdsById: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody:
    | {
        status?: "in-review" | "disabled";
        /** Topic of the content */
        topic?: SiteAdsTopic;
      }
    | undefined;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/ads",
  method: "post",
  streaming: false,
  tags: ["site-ads"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-ads
 * @name AdsListSites
 * @summary List all the sites with ads configured
 * @request GET:/ads/sites
 * @secure
 */

// @ts-ignore
export const adsListSites: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {};
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * Filter sites by their ads review status
     * @default "in-review"
     */
    status?: "in-review" | "live" | "rejected";
  };
  RequestBody: never;
  RequestHeaders: {
    "X-GitBook-Partner-Key": string;
  };
  ResponseBody: List & {
    items: ({
      id: string;
      url: string;
      email: string;
      /** Topic of the content */
      topic: SiteAdsTopic;
    } & (
      | {
          status: "in-review";
        }
      | {
          status: "live";
          /** The ad network zone ID */
          zoneId: string;
        }
      | {
          status: "rejected";
          /** Reason for the rejection */
          reason?: string;
        }
    ))[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/ads/sites",
  method: "get",
  streaming: false,
  tags: ["site-ads"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-ads
 * @name AdsUpdateSite
 * @summary Update the Ads configuration for a site
 * @request PATCH:/ads/sites/{siteId}
 * @secure
 */

// @ts-ignore
export const adsUpdateSite: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody:
    | {
        status: "live";
        /** ID of the zone */
        zoneId: string;
        /** ID to fetch reporting data */
        reportingId: string;
      }
    | {
        status: "rejected";
        /**
         * Reason for the rejection
         * @maxLength 512
         */
        reason?: string;
      }
    | {
        status: "pending";
      };
  RequestHeaders: {
    "X-GitBook-Partner-Key": string;
  };
  ResponseBody: void;
  ResponseStatusCode: 204;
} = {
  route: "/ads/sites/{siteId}",
  method: "patch",
  streaming: false,
  tags: ["site-ads"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
